import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import ValidLocales from './locales';

i18next.use(initReactI18next).init({
    fallbackLng: 'en',
    debug: true,
    // if you see an error like: "Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz"
    // set returnNull to false (and also in the i18next.d.ts options)
    // returnNull: false,
});

export type Locale = (typeof ValidLocales)[number];

function isValidLocale(value?: string | null): value is Locale {
    return !!value && (ValidLocales as readonly string[]).includes(value);
}

// Use same function for gettting default locale
export function sanitiseLocale(value?: string | null): Locale {
    if (!value) {
        return 'en-US';
    }

    const locale = value
        .split('-')
        .map((part, index) => (index === 0 ? part.toLowerCase() : part.toUpperCase()))
        .join('-');

    return isValidLocale(locale) ? locale : 'en-US';
}
